<template>
  <div class="bonus-cont container fade-up" v-in-viewport.once>
    <div class="theory-of-change">
      <div class="inner container">
        <div class="top-cont">
          <p class="title font-34 f-roman">{{ _.get(getData, "title") }}</p>
          <p class="desc font-34 f-roman">
            {{ _.get(getData, "teaser") }}
          </p>
        </div>
        <div class="cont">
          <div class="Top-triangle icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="14"
              viewBox="0 0 16 14"
            >
              <path
                id="Polygon_20"
                data-name="Polygon 20"
                d="M8,0l8,14H0Z"
                fill="#e3b505"
              />
            </svg>
          </div>
          <div class="Bottom-triangle icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="14"
              viewBox="0 0 16 14"
            >
              <path
                id="Polygon_20"
                data-name="Polygon 20"
                d="M8,0l8,14H0Z"
                fill="#e3b505"
              />
            </svg>
          </div>
          <div class="left-triangle icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="14"
              viewBox="0 0 16 14"
            >
              <path
                id="Polygon_12"
                data-name="Polygon 12"
                d="M8,0l8,14H0Z"
                fill="#e3b505"
              />
            </svg>
          </div>
          <div class="right-triangle icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="14"
              viewBox="0 0 16 14"
            >
              <path
                id="Polygon_8"
                data-name="Polygon 8"
                d="M8,0l8,14H0Z"
                transform="translate(16 14) rotate(180)"
                fill="#e3b505"
              />
            </svg>
          </div>
          <swiper
            ref="theorySwiper"
            class="swiper-cont"
            :options="swiperOptions"
          >
            <swiper-slide
              class="single-slide"
              v-for="(item, index) in _.get(getData, 'content.tabs')"
              :key="index"
            >
              <div class="box">
                <div class="top-triangle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                  >
                    <path
                      id="Polygon_5"
                      data-name="Polygon 5"
                      d="M8,0l8,14H0Z"
                      transform="translate(14) rotate(90)"
                      fill="#e3b505"
                    />
                  </svg>
                </div>
                <div class="bottom-tringle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                  >
                    <path
                      id="Polygon_11"
                      data-name="Polygon 11"
                      d="M8,0l8,14H0Z"
                      transform="translate(0 16) rotate(-90)"
                      fill="#e3b505"
                    />
                  </svg>
                </div>
                <p class="font-16 f-medium">
                  {{ _.get(item, "title") }}
                </p>
              </div>
            </swiper-slide>
            <div class="swiper-scrollbar" slot="scrollbar">
              <div class="swiper-scrollbar-drag" slot="scrollbar"></div>
            </div>
          </swiper>
        </div>
        <p class="sub-title font-21 f-bold">
          {{ _.get(getData, "content.teaser") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      swiperOptions: {
        watchOverflow: true,
        slidesPerView: 4.9,
        speed: 1000,
        slideToClickedSlide: false,
        mousewheel: {
          releaseOnEdges: true
        },
        scrollbar: {
          el: ".theory-of-change .swiper-scrollbar",
          draggable: true,
          dragSize: 142
        },
        breakpoints: {
          320: {
            releaseOnEdges: false
          },
          768: {
            slidesPerView: 2.8,
            releaseOnEdges: true
          },
          1023: {
            slidesPerView: 3.1
          },
          1365: {
            slidesPerView: 4.9
          }
        }
      }
    };
  },
  computed: {
    getData() {
      return _.get(this.contentData, "data.list.0");
    }
  }
};
</script>

<style lang="scss">
body.white .theory-of-change {
  .swiper-container::after {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='blue' stroke-width='1' stroke-dasharray='9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e") !important;
  }
  .desc {
    color: var(--bonus-txt);
  }
}
body.yellow .theory-of-change {
  .swiper-container::after {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='black' stroke-width='1' stroke-dasharray='9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e") !important;
  }
  .desc {
    color: var(--bonus-txt) !important;
  }
  .box {
    border-right: 1px solid #cdce28 !important;
  }
}
body.black .theory-of-change {
  .swiper-container::after {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='yellow' stroke-width='1' stroke-dasharray='9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e") !important;
  }
  .desc {
    color: var(--bonus-txt) !important;
  }
  .box {
    border-right: none !important;
  }
  .box::after {
    background-color: #fefe00 !important;
  }
}

.bonus-cont {
  margin-top: 143px;
  &.fade-up.in-viewport {
    opacity: 1;
    transform: translateY(0px);
  }
  @media (max-width: 1679px) {
    margin-top: 110px;
  }
  @media (max-width: 1439px) {
    margin-top: 144px;
  }
  @media (max-width: 1023px) {
    margin-top: 89px;
  }
  &.container {
    width: unset;
  }
  @media (min-width: 768px) {
    padding: 0px;
    width: 100%;
  }
}
.theory-of-change {
  padding-top: 81px;
  padding-bottom: 81px;
  border: 2px solid var(--secondary-txt);
  @media (max-width: 1365px) {
    border-right: none;
  }
  @media (max-width: 767px) {
    border-right: 2px solid var(--secondary-txt);
  }
  .inner {
  }
  @media (max-width: 1439px) {
    padding-top: 81px;
    padding-bottom: 70px;
  }
  @media (max-width: 1023px) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  @media (max-width: 767px) {
    padding-top: 33px;
    padding-bottom: 23px;
  }
  .bonus-cont {
    @media (min-width: 768px) {
      padding: 0;
    }
  }
  .inner {
    .title {
      color: var(--bonus-txt);
      margin-bottom: 30px;
      @media (max-width: 767px) {
        margin-bottom: 23px;
      }
    }
    .desc {
      color: #212d36;
      @media (max-width: 1365px) {
        font-size: 21px;
      }
    }
    .cont {
      @media (max-width: 767px) {
        pointer-events: none;
        margin-top: 22px;
      }
      .swiper-scrollbar {
        display: none;
      }
      .swiper-container-horizontal > .swiper-scrollbar {
        height: 2px;
        @media (max-width: 1365px) {
          width: calc(100% - 50px);
        }
      }
      .swiper-scrollbar-drag {
        top: -2px;
        height: 5px;
        background: var(--bonus);
      }
      @media (max-width: 1365px) {
        .swiper-scrollbar {
          display: block;
        }
      }
      @media (max-width: 767px) {
        .swiper-scrollbar {
          display: none;
        }
      }
      position: relative;
      margin-top: 45px;
      // height: 174px;
      border-radius: 25px;
      .left-triangle,
      .right-triangle,
      .Top-triangle,
      .Bottom-triangle {
        position: absolute;
      }
      .Top-triangle {
        top: 0;
        left: 50%;
        transform: translateX(-50%) rotate(-30deg);
        @media (min-width: 768px) {
          display: none;
        }
      }
      .Bottom-triangle {
        bottom: 32px;
        left: 50%;
        transform: translateX(-50%) rotate(30deg);
        @media (min-width: 768px) {
          display: none;
        }
      }
      .left-triangle {
        left: -8px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 1365px) {
          top: calc(50% - 20px);
        }
      }
      .right-triangle {
        right: -8px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 1365px) {
          top: calc(50% - 20px);
          display: none;
        }
        @media (max-width: 767px) {
          display: block;
        }
      }
      .swiper-container {
        // border-radius: 25px;
        padding: 8px 0 !important;
        height: 190px;
        @media (max-width: 1365px) {
          height: calc(190px + 35px);
          padding: 8px 0px 35px !important;
          width: calc(100% + 50px);
        }
        @media (max-width: 767px) {
          padding: unset !important;
          height: unset;
          width: 100%;
        }
      }
      .swiper-container::after {
        content: "";
        position: absolute;
        top: 8px;
        left: 0;
        width: 100%;
        height: calc(100% - 15px);
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='%23E3B505FF' stroke-width='1' stroke-dasharray='9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e");
        @media (max-width: 1365px) {
          height: calc(100% - 44px);
        }
      }
      .single-slide {
        &:last-child .box {
          &::after {
            display: none;
          }
          border-right: none;
          border-bottom: none;
          padding-bottom: 0px;
          .top-triangle,
          .bottom-tringle {
            display: none;
          }
        }
      }
      .swiper-wrapper {
        @media (max-width: 1365px) {
          margin-bottom: 40px;
        }
        @media (min-width: 1366px) {
          transform: translate3d(0px, 0, 0) !important;
        }
        .cont {
          .swiper-scrollbar {
            display: none;
          }
          .swiper-container-horizontal > .swiper-scrollbar {
            height: 2px;
            @media (max-width: 1365px) {
              width: calc(100% - 50px);
            }
          }
          .swiper-scrollbar-drag {
            top: -2px;
            height: 5px;
            background: var(--bonus);
          }
          @media (max-width: 1365px) {
            .swiper-scrollbar {
              display: block;
            }
            transform: translateX(51px);
          }
          @media (max-width: 767px) {
            pointer-events: none;
            margin-top: 22px;
            transform: translateX(0px);
          }
          @media (max-width: 767px) {
            .swiper-scrollbar {
              display: none;
            }
          }
          position: relative;
          margin-top: 45px;
          // height: 174px;
          border-radius: 25px;
          .left-triangle,
          .right-triangle,
          .Top-triangle,
          .Bottom-triangle {
            position: absolute;
          }
          .Top-triangle {
            top: 0;
            left: 50%;
            transform: translateX(-50%) rotate(-30deg);
            @media (min-width: 768px) {
              display: none;
            }
          }
          .Bottom-triangle {
            bottom: 32px;
            left: 50%;
            transform: translateX(-50%) rotate(30deg);
            @media (min-width: 768px) {
              display: none;
            }
          }
          .left-triangle {
            left: -8px;
            top: 50%;
            transform: translateY(-50%);
            @media (max-width: 1365px) {
              top: calc(50% - 20px);
            }
          }
          .right-triangle {
            right: -8px;
            top: 50%;
            transform: translateY(-50%);
            @media (max-width: 1365px) {
              top: calc(50% - 20px);
            }
          }
          .swiper-container {
            // border-radius: 25px;
            padding: 8px 0 !important;
            @media (max-width: 767px) {
              padding: unset !important;
            }
          }
          .swiper-container::after {
            content: "";
            position: absolute;
            top: 8px;
            left: 0;
            width: 100%;
            height: calc(100% - 15px);
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='%23E3B505FF' stroke-width='1' stroke-dasharray='9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e");
            @media (max-width: 1365px) {
              height: calc(100% - 60px);
            }
          }
          .single-slide {
            &:last-child .box {
              &::after {
                display: none;
              }
              border-right: none;
              border-bottom: none;
              .top-triangle,
              .bottom-tringle {
                display: none;
              }
            }
          }
          .swiper-wrapper {
            @media (min-width: 1366px) {
              transform: translate3d(0px, 0, 0) !important;
            }
            @media (max-width: 1365px) {
              margin-bottom: 42px;
            }
            @media (max-width: 767px) {
              transform: translate3d(0px, 0, 0) !important;
              flex-direction: column;
              .swiper-slide {
                width: unset !important;
              }
            }
          }
          .swiper-slide {
            @media (max-width: 767px) {
              padding-left: 20px;
              padding-right: 20px;
              // padding-top: 30px;
              padding-bottom: 30px;
              &:first-child {
                padding-top: 30px;
              }
            }
          }
          .box {
            position: relative;
            padding-left: 10px;
            padding-right: 10px;
            border-right: 1px solid #dfdfdf;
            padding-top: 22px;
            // padding-bottom: 42px;
            height: 100%;
            @media (max-width: 767px) {
              height: unset;
              padding: 0px;
              border-bottom: 1px solid #dfdfdf;
              border-right: none;
              padding-bottom: 21px;
            }
            &::after {
              content: "";
              position: absolute;
              right: -1px;
              width: 1px;
              top: 50%;
              height: 50%;
              background-color: #0d1317;
              transform: translateY(-50%);
              @media (max-width: 767px) {
                background: none;
              }
            }
            .top-triangle,
            .bottom-tringle {
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              @media (max-width: 767px) {
                display: none;
              }
            }
            .top-triangle {
              top: -8px;
              right: -11px;
            }
            .bottom-tringle {
              bottom: -8px;
              right: -6px;
              @media (max-width: 1365px) {
                bottom: -5px;
              }
            }
            p {
              color: var(--bonus);
              line-height: 24px;
              overflow: hidden;
              display: -webkit-box;
              font-size: 14px;
              -webkit-box-orient: vertical;
              // -webkit-line-clamp: 4;
            }
          }
        }
        @media (max-width: 767px) {
          transform: translate3d(0px, 0, 0) !important;
          flex-direction: column;
          .swiper-slide {
            width: unset !important;
          }
        }
      }
      .swiper-slide {
        @media (max-width: 767px) {
          padding-left: 20px;
          padding-right: 20px;
          // padding-top: 30px;
          padding-bottom: 30px;
          &:first-child {
            padding-top: 30px;
          }
        }
      }
      .box {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
        border-right: 1px solid #dfdfdf;
        padding-top: 22px;
        // padding-bottom: 42px;
        height: 100%;
        @media (max-width: 767px) {
          height: unset;
          padding: 0px;
          border-bottom: 1px solid #dfdfdf;
          border-right: none;
          padding-bottom: 21px;
        }
        &::after {
          content: "";
          position: absolute;
          right: -1px;
          width: 1px;
          top: 50%;
          height: 50%;
          background-color: #0d1317;
          transform: translateY(-50%);
          @media (max-width: 767px) {
            background: none;
          }
        }
        .top-triangle,
        .bottom-tringle {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          @media (max-width: 767px) {
            display: none;
          }
        }
        .top-triangle {
          top: -8px;
          right: -11px;
        }
        .bottom-tringle {
          bottom: -8px;
          right: -6px;
          @media (max-width: 1365px) {
            bottom: -5px;
          }
        }
        p {
          color: var(--bonus-txt);
          line-height: 24px;
          font-size: 14px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          // -webkit-line-clamp: 4;
        }
      }
    }
    .sub-title {
      color: var(--primary-txt);
      margin-top: 35px;
      padding-right: 36px;
      @media (max-width: 1439px) {
        margin-top: 62px;
      }
      @media (max-width: 1023px) {
        margin-top: 34px;
        font-size: 16px;
      }
      @media (max-width: 767px) {
        margin-top: 0px;
        padding-right: 0px;
      }
    }
  }
}
</style>
